services.factory('$exceptionHandler', [
    '$log', '$window', 'constants', 'ErrorService',
    function ($log, $window, constants, ErrorService) {
        var Rollbar;

        if ($window.hasOwnProperty('Rollbar')) {
            Rollbar = $window.Rollbar;
        }

        function handleApplicationError(error) {
            switch (error.severity) {
            case 'info':
                return $log.info('Handler', error);
            case 'warning':
                Rollbar && Rollbar
                    .scope(format(error))
                    .warning(format(error).message);
                return $log.warn('Handler', error);
            case 'critical':
                Rollbar && Rollbar
                    .scope(format(error))
                    .error(format(error).message);
                return $log.error('Handler', error);
            default:
                return $log.debug('Handler', error)
            }
        }

        function handleGeneralError(error) {
            Rollbar && Rollbar
                .error(error);
            return $log.error('Application error', error)
        }

        function format(error) {
            return {
                source: error.source,
                type: constants.error.typeById[error.type],
                severity: error.severity,
                message: error.message || error.code,
                data: error.data
            }
        }

        return function ExceptionHandler(error) {
            return (typeof error === 'object' && error instanceof ErrorService)
                ? handleApplicationError(error)
                : handleGeneralError(error)

        }

    }]);